module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp12_6.92edd6cf.png";